import { VuexPersistence } from 'vuex-persist'
import { Context } from '@nuxt/types'
import Cookies from 'js-cookie'

const TTL_DAYS = 0.5 // 12 hours

export default function (ctx: Context) {
  const { store } = ctx

  new VuexPersistence({
    reducer: (state: any) => {
      return {
        modules: {
          Cart: state.modules.Cart,
          redirect: state.modules.redirect,
          Amp: {
            Filters: {
              Common: state.modules.Amp.Filters.Common,
              Mobile: state.modules.Amp.Filters.Mobile,
              Home: state.modules.Amp.Filters.Home,
            },
          },
        },
      }
    },
    restoreState: (key, _storage) => {
      const value = Cookies.get(key)

      if (value) {
        try {
          return JSON.parse(value)
        } catch (e) {
          return {}
        }
      }
    },
    saveState: (key, state, _storage) => {
      Cookies.set(key, JSON.stringify(state), {
        expires: TTL_DAYS,
      })
    },
  }).plugin(store)
}
